import styled from "styled-components";
import { Button } from "@mui/material";
import FontStyles from "../styles/fontStyles";
import ButtonContainedComponent from "../buttons/ButtonContained";
import { ButtonText } from "..";

export const ClearButton = styled(ButtonText)(({ theme }) => ({
  "&&.MuiButton-root": {
    color: theme.palette.text.primary,
    ...FontStyles.medium14,
    margin: 0,
    padding: "18px",
    paddingInline: "35px",
    textTransform: "uppercase" as const,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      paddingBlock: "12px",
      paddingInline: "25px",
    },
  },
}));

export const SubmitButton = styled(ButtonContainedComponent)(({ theme }) => ({
  "&&.MuiButton-root": {
    ...FontStyles.medium14,
    padding: "18px",
    paddingInline: "35px",
    margin: 0,
    textTransform: "uppercase" as const,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      paddingBlock: "12px",
      paddingInline: "25px",
    },
  },
}));
